import { useTranslations } from 'next-intl';

import { PageLayout, Title } from '../../../components';

import { ForgotPasswordPage } from '@zapier/auth-pages';

export default function ForgotPassword() {
  const t = useTranslations('forgot-password');
  return (
    <Title title={t('page-title')}>
      <PageLayout>
        <ForgotPasswordPage />
      </PageLayout>
    </Title>
  );
}
